export default "__VITE_ASSET__DfohYw4Y__"